import "./TagOverflowHandle.css";
import React, {
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import GenericTagComp from "../genericComponents/tag/GenericTagComp";

const getTagColorPerTxt = (text) => {
  switch (text) {
    case "Commercial Airplanes":
    case "Defense":
    case "Nudge":  
    case "in-progress": 
      return "blue";
    case "New Growth Area":
    case "Higher Spending":  
    case "increased":
    case "Mission Critical Priority":
    case "Strategic Market Expansion": 
      return "green";
    case "Pain point":
    case "Active Challenge":
      return "red";  
    case "Mission Critical Priority":
      return "yellow";
    default:
      return "gray"; // fallback color for any other text
  }
};



function TagOverflowHandlerV2({ data,onChipClick=null }) {

  if (!data) {
    return null;
  }
  return (
    <div>
      {Array.isArray(data) ? (
        data?.map((item) => (
          <GenericTagComp
            color={getTagColorPerTxt(item)}
            text={item}
            onChipClick={onChipClick}
          />
        ))
      ) : (
        <GenericTagComp
          color={getTagColorPerTxt(data)}
          text={data}
          onChipClick={onChipClick}
        />
      )}
    </div>
  );
}

export default TagOverflowHandlerV2;
